import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import "./sections.css";
import "./Contact.css";
import { I18nProvider } from "../../i18n";
import translate from "../../i18n/translate";
import Alert from "@material-ui/lab/Alert";
import IconButton from "@material-ui/core/IconButton";
import Collapse from "@material-ui/core/Collapse";
import CloseIcon from "@material-ui/icons/Close";
import LegalMentions from "../LegalMentions";

export default function Contact({ isMobile, locale }) {
  const useStyles = makeStyles((theme) => ({
    alert: {
      position: "fixed",
      bottom: "20px",
      left: "20px",
    },
  }));

  const classes = useStyles();
  const [copied, setCopied] = React.useState(false);
  function copy() {
    let text = "leo.moscillo@gmail.com";
    var input = document.body.appendChild(document.createElement("input"));
    input.value = text;
    input.focus();
    input.select();
    document.execCommand("copy");
    input.parentNode.removeChild(input);
    setCopied(true);
  }

  const [openLegal, setOpenLegal] = useState(false);
  const handleOpenLegal = () => {
    setOpenLegal(true);
  };
  const handleCloseLegal = () => {
    setOpenLegal(false);
  };
  return (
    <div id="contact" className="section">
      <div id="contact-link">
        <div id="mail-svg">
          <svg viewBox="0 0 32 32">
            <g id="background">
              <rect fill="none" width="32" height="32" id="rect3037" />
            </g>
            <path
              id="path3040"
              d="M 0,4 V 28 H 32 V 4 H 0 z M 28.149,6 15.998,15.719 3.851,6 H 28.149 z M 2,25.999 V 7.081 L 15.998,18.278 29.999,7.081 V 25.999 H 2 z"
            />
          </svg>
          <svg viewBox="0 0 51.167763 71.883881">
            <line
              x1="25.683882"
              y1="0"
              x2="25.683882"
              y2="60.400002"
              className="line"
            />
            <line
              x1="40.283882"
              y1="45.400002"
              x2="24.683882"
              y2="61"
              className="line"
            />
            <line
              x1="10.883883"
              y1="45.400002"
              x2="26.483885"
              y2="61"
              className="line"
            />
          </svg>
        </div>
        <p onClick={copy}>leo.moscillo@gmail.com</p>
        <p>
          <I18nProvider locale={locale}>
            {translate("contactResume")}
          </I18nProvider>
        </p>
        <div id="link-resume">
          {locale === "fr-fr" ? (
            <a href="./CV/CV MOSCILLO Léo FR.pdf" target="blank">
              PDF
            </a>
          ) : (
            <a href="./CV/CV MOSCILLO Léo EN.pdf" target="blank">
              PDF
            </a>
          )}
          <a
            href="https://www.linkedin.com/in/l%C3%A9o-moscillo-827517189/"
            target="_blank"
            rel="noreferrer"
          >
            LINKEDIN
          </a>
        </div>
        <p onClick={handleOpenLegal}>
          <I18nProvider locale={locale}>
            {translate("contactLegal")}
          </I18nProvider>
        </p>
      </div>
      <div>
        <img
          id="photo-tres-hot"
          alt="Léo Moscillo"
          src="leo-tres-tres-beau-et-super-sexy.jpg"
        ></img>
        <div id="social-network">
          <a
            href="https://www.youtube.com/channel/UCqGURNS1WM9dRu7rv2te_uw"
            target="_blank"
            rel="noreferrer"
          >
            <svg viewBox="0 0 512 512">
              <path d="M449.446,0c34.525,0 62.554,28.03 62.554,62.554l0,386.892c0,34.524 -28.03,62.554 -62.554,62.554l-386.892,0c-34.524,0 -62.554,-28.03 -62.554,-62.554l0,-386.892c0,-34.524 28.029,-62.554 62.554,-62.554l386.892,0Zm-20.967,175.63c-4.139,-15.489 -16.337,-27.687 -31.826,-31.826c-28.078,-7.524 -140.653,-7.524 -140.653,-7.524c0,0 -112.575,0 -140.653,7.524c-15.486,4.139 -27.686,16.337 -31.826,31.826c-7.521,28.075 -7.521,86.652 -7.521,86.652c0,0 0,58.576 7.521,86.648c4.14,15.489 16.34,27.69 31.826,31.829c28.078,7.521 140.653,7.521 140.653,7.521c0,0 112.575,0 140.653,-7.521c15.489,-4.139 27.687,-16.34 31.826,-31.829c7.521,-28.072 7.521,-86.648 7.521,-86.648c0,0 0,-58.577 -7.521,-86.652Zm-208.481,140.653l0,-108.002l93.53,54.001l-93.53,54.001Z" />
            </svg>
          </a>
          <a
            href="https://www.instagram.com/ollicsom/"
            target="_blank"
            rel="noreferrer"
          >
            <svg viewBox="0 0 512 512">
              <path d="M449.446,0c34.525,0 62.554,28.03 62.554,62.554l0,386.892c0,34.524 -28.03,62.554 -62.554,62.554l-386.892,0c-34.524,0 -62.554,-28.03 -62.554,-62.554l0,-386.892c0,-34.524 28.029,-62.554 62.554,-62.554l386.892,0Zm-193.446,81c-47.527,0 -53.487,0.201 -72.152,1.053c-18.627,0.85 -31.348,3.808 -42.48,8.135c-11.508,4.472 -21.267,10.456 -30.996,20.184c-9.729,9.729 -15.713,19.489 -20.185,30.996c-4.326,11.132 -7.284,23.853 -8.135,42.48c-0.851,18.665 -1.052,24.625 -1.052,72.152c0,47.527 0.201,53.487 1.052,72.152c0.851,18.627 3.809,31.348 8.135,42.48c4.472,11.507 10.456,21.267 20.185,30.996c9.729,9.729 19.488,15.713 30.996,20.185c11.132,4.326 23.853,7.284 42.48,8.134c18.665,0.852 24.625,1.053 72.152,1.053c47.527,0 53.487,-0.201 72.152,-1.053c18.627,-0.85 31.348,-3.808 42.48,-8.134c11.507,-4.472 21.267,-10.456 30.996,-20.185c9.729,-9.729 15.713,-19.489 20.185,-30.996c4.326,-11.132 7.284,-23.853 8.134,-42.48c0.852,-18.665 1.053,-24.625 1.053,-72.152c0,-47.527 -0.201,-53.487 -1.053,-72.152c-0.85,-18.627 -3.808,-31.348 -8.134,-42.48c-4.472,-11.507 -10.456,-21.267 -20.185,-30.996c-9.729,-9.728 -19.489,-15.712 -30.996,-20.184c-11.132,-4.327 -23.853,-7.285 -42.48,-8.135c-18.665,-0.852 -24.625,-1.053 -72.152,-1.053Zm0,31.532c46.727,0 52.262,0.178 70.715,1.02c17.062,0.779 26.328,3.63 32.495,6.025c8.169,3.175 13.998,6.968 20.122,13.091c6.124,6.124 9.916,11.954 13.091,20.122c2.396,6.167 5.247,15.433 6.025,32.495c0.842,18.453 1.021,23.988 1.021,70.715c0,46.727 -0.179,52.262 -1.021,70.715c-0.778,17.062 -3.629,26.328 -6.025,32.495c-3.175,8.169 -6.967,13.998 -13.091,20.122c-6.124,6.124 -11.953,9.916 -20.122,13.091c-6.167,2.396 -15.433,5.247 -32.495,6.025c-18.45,0.842 -23.985,1.021 -70.715,1.021c-46.73,0 -52.264,-0.179 -70.715,-1.021c-17.062,-0.778 -26.328,-3.629 -32.495,-6.025c-8.169,-3.175 -13.998,-6.967 -20.122,-13.091c-6.124,-6.124 -9.917,-11.953 -13.091,-20.122c-2.396,-6.167 -5.247,-15.433 -6.026,-32.495c-0.842,-18.453 -1.02,-23.988 -1.02,-70.715c0,-46.727 0.178,-52.262 1.02,-70.715c0.779,-17.062 3.63,-26.328 6.026,-32.495c3.174,-8.168 6.967,-13.998 13.091,-20.122c6.124,-6.123 11.953,-9.916 20.122,-13.091c6.167,-2.395 15.433,-5.246 32.495,-6.025c18.453,-0.842 23.988,-1.02 70.715,-1.02Zm0,53.603c-49.631,0 -89.865,40.234 -89.865,89.865c0,49.631 40.234,89.865 89.865,89.865c49.631,0 89.865,-40.234 89.865,-89.865c0,-49.631 -40.234,-89.865 -89.865,-89.865Zm0,148.198c-32.217,0 -58.333,-26.116 -58.333,-58.333c0,-32.217 26.116,-58.333 58.333,-58.333c32.217,0 58.333,26.116 58.333,58.333c0,32.217 -26.116,58.333 -58.333,58.333Zm114.416,-151.748c0,11.598 -9.403,20.999 -21.001,20.999c-11.597,0 -20.999,-9.401 -20.999,-20.999c0,-11.598 9.402,-21 20.999,-21c11.598,0 21.001,9.402 21.001,21Z" />
            </svg>
          </a>
          <a
            href="https://github.com/Ollicsom"
            target="_blank"
            rel="noreferrer"
          >
            <svg viewBox="0 0 1080 1080">
              <path
                d="M1368.05,1080a132,132,0,0,0,132-132V132A132,132,0,0,0,1368.05,0H552A132,132,0,0,0,420,132v816.1a132,132,0,0,0,132,132h282.8V904.6c-23.12,5.06-44.4,5.21-67.94-1.73-31.59-9.32-57.25-30.36-76.3-62.44-12.14-20.48-33.66-42.69-56.11-41.06L628.9,737c48.54-4.16,90.54,29.57,115.46,71.45,11.08,18.63,23.82,29.54,40.18,34.37,15.81,4.66,32.79,2.42,52.57-4.56,5-39.61,23.11-54.43,36.82-75.31v0C734.73,742.15,679.26,668.3,657.24,610c-29.17-77.4-13.51-174.08,38.08-235.18,1-1.19,2.81-4.31,2.11-6.48-23.66-71.46,5.17-130.57,6.23-136.84,27.3,8.07,31.74-8.12,118.59,44.64l15,9c6.28,3.75,4.3,1.61,10.58,1.14A453.57,453.57,0,0,1,960,270.54a455.45,455.45,0,0,1,113.69,16.18l4.86.49c-.42-.07,1.32-.31,4.25-2.06,108.49-65.71,104.59-44.24,133.69-53.7,1,6.28,29.49,66.36,6.09,136.91-3.16,9.72,94.06,98.74,40.18,241.63-22,58.31-77.49,132.16-216.68,152.92v0c17.84,27.2,39.28,41.66,39.17,97.76V1080Z"
                transform="translate(-420)"
              />
            </svg>
          </a>
          <a
            href="https://twitter.com/Ollicsom"
            target="_blank"
            rel="noreferrer"
          >
            <svg viewBox="0 0 512 512" width="100%">
              <path d="M449.446,0c34.525,0 62.554,28.03 62.554,62.554l0,386.892c0,34.524 -28.03,62.554 -62.554,62.554l-386.892,0c-34.524,0 -62.554,-28.03 -62.554,-62.554l0,-386.892c0,-34.524 28.029,-62.554 62.554,-62.554l386.892,0Zm-253.927,424.544c135.939,0 210.268,-112.643 210.268,-210.268c0,-3.218 0,-6.437 -0.153,-9.502c14.406,-10.421 26.973,-23.448 36.935,-38.314c-13.18,5.824 -27.433,9.809 -42.452,11.648c15.326,-9.196 26.973,-23.602 32.49,-40.92c-14.252,8.429 -30.038,14.56 -46.896,17.931c-13.487,-14.406 -32.644,-23.295 -53.946,-23.295c-40.767,0 -73.87,33.104 -73.87,73.87c0,5.824 0.613,11.494 1.992,16.858c-61.456,-3.065 -115.862,-32.49 -152.337,-77.241c-6.284,10.881 -9.962,23.601 -9.962,37.088c0,25.594 13.027,48.276 32.95,61.456c-12.107,-0.307 -23.448,-3.678 -33.41,-9.196l0,0.92c0,35.862 25.441,65.594 59.311,72.49c-6.13,1.686 -12.72,2.606 -19.464,2.606c-4.751,0 -9.348,-0.46 -13.946,-1.38c9.349,29.426 36.628,50.728 68.965,51.341c-25.287,19.771 -57.164,31.571 -91.8,31.571c-5.977,0 -11.801,-0.306 -17.625,-1.073c32.337,21.15 71.264,33.41 112.95,33.41Z" />
            </svg>
          </a>
          <a
            href="https://www.linkedin.com/in/l%C3%A9o-moscillo-827517189/"
            target="_blank"
            rel="noreferrer"
          >
            <svg viewBox="0 0 512 512">
              <path d="M449.446,0c34.525,0 62.554,28.03 62.554,62.554l0,386.892c0,34.524 -28.03,62.554 -62.554,62.554l-386.892,0c-34.524,0 -62.554,-28.03 -62.554,-62.554l0,-386.892c0,-34.524 28.029,-62.554 62.554,-62.554l386.892,0Zm-288.985,423.278l0,-225.717l-75.04,0l0,225.717l75.04,0Zm270.539,0l0,-129.439c0,-69.333 -37.018,-101.586 -86.381,-101.586c-39.804,0 -57.634,21.891 -67.617,37.266l0,-31.958l-75.021,0c0.995,21.181 0,225.717 0,225.717l75.02,0l0,-126.056c0,-6.748 0.486,-13.492 2.474,-18.315c5.414,-13.475 17.767,-27.434 38.494,-27.434c27.135,0 38.007,20.707 38.007,51.037l0,120.768l75.024,0Zm-307.552,-334.556c-25.674,0 -42.448,16.879 -42.448,39.002c0,21.658 16.264,39.002 41.455,39.002l0.484,0c26.165,0 42.452,-17.344 42.452,-39.002c-0.485,-22.092 -16.241,-38.954 -41.943,-39.002Z" />
            </svg>
          </a>
          <a
            href="https://www.codingame.com/profile/81085032dcd103aaa01bfadc2fe713bd8611856"
            target="_blank"
            rel="noreferrer"
          >
            <svg viewBox="0 0 512 512">
              <path d="M0,394.1V.25Q250.68.25,501.35,0c8.76,0,10.5,1.72,10.48,10.48q-.49,245.52,0,491c0,8.76-1.71,10.5-10.47,10.48q-191.85-.54-383.69-.25c-13.37-59.58,1.35-110.2,47.27-151.49,24.5-22,52.71-37,83.26-48.6,26.16-10,53.56-17.8,75.37-36.76,20.73-18,29-58.64,17.33-83.84-10.83-23.32-38.88-35-69.8-30.33-45.32,6.8-83.06,41.74-85.52,90.86C184,283.43,170.31,310,147,331.11,105.33,368.9,53.87,384.46,0,394.1Z" transform="translate(0 0)" /></svg>
          </a>
        </div>
      </div>
      <Collapse in={copied} className={classes.alert}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setCopied(false);
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
        >
          <I18nProvider locale={locale}>{translate("copy")}</I18nProvider>
        </Alert>
      </Collapse>
      <LegalMentions
        isMobile={isMobile}
        locale={locale}
        openLegal={openLegal}
        handleCloseLegal={handleCloseLegal}
      />
    </div>
  );
}
